module.exports = __webpack_public_path__ + "static/media/place.bc9c9c2c.png";